import React, { useState } from "react";
import { Button, Grid, Header, Label, Modal } from "semantic-ui-react";
import { ApproverAssetSelectionCarousel } from "../ApproverAssetSelectionCarousel/ApproverAssetSelectionCarousel";

export const ApproverAssetSelectionModal = ({
  approver,
  assets,
  t,
  handleAssetChange,
  approverAssetMap,
}) => {
  // For Modal
  const [isOpen, setIsOpen] = useState(false);
  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  return (
    <>
      <Grid.Row style={{ padding: ".2rem 1rem .2rem", marginTop: "1rem" }}>
        <Header size="tiny">
          {t("approvals_select_assets_for")} {approver.name}
        </Header>
      </Grid.Row>
      <Grid.Row columns={2} style={{ padding: "0px" }}>
        <Grid.Column width={"3"}>
          <Modal
            className="modal"
            trigger={
              <Button
                style={{
                  backgroundColor: "#4700a3",
                  color: "white",
                }}
                onClick={handleOpen}
              >
                {t("approvals_approver_asset_selection_modal_pick_assets")}
              </Button>
            }
            open={isOpen}
            style={{ width: "104rem" }}
            onClose={handleClose}
          >
            <Modal.Content>
              <ApproverAssetSelectionCarousel
                approver={approver}
                assets={assets}
                t={t}
                handleAssetChange={handleAssetChange}
                approverAssetMap={approverAssetMap}
              />
            </Modal.Content>
            <Modal.Actions>
              <Button color="red" onClick={handleClose}>
                {t("close")}
              </Button>
              <Button
                style={{
                  backgroundColor: "#4700a3",
                  color: "white",
                }}
                onClick={() => {
                  handleClose();
                }}
              >
                {t("save")}
              </Button>
            </Modal.Actions>
          </Modal>
        </Grid.Column>
        <Grid.Column>
          <Label>
            {approverAssetMap[approver.id]?.selectedItems?.length > 0
              ? `${approverAssetMap[approver.id]?.selectedItems.length} Assets`
              : t("approvals_approver_asset_selection_modal_pick_assets_label_no_assets_selected")}
          </Label>
        </Grid.Column>
      </Grid.Row>
    </>
  );
};
